export default __webpack_public_path__ + "assets/media/13-1-2320317-1583144179933.jpg";